import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Loader2 } from 'lucide-react';
import { useAuth, API } from '@/context/AuthContext';

export const EmailOtpLogin = ({ onDone }) => {
  const { setAuthData } = useAuth();
  const [open, setOpen] = useState(false);
  const [identifier, setIdentifier] = useState('');
  const [otp, setOtp] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const requestCode = async () => {
    if (!identifier.trim()) return toast.error('Enter your Member ID or registered email');
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/login-otp/request`, { identifier: identifier.trim() });
      setSent(true);
      toast.success(r.data.message);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not send the code. Please try again.');
    }
    setBusy(false);
  };

  const verify = async () => {
    if (otp.trim().length !== 6) return toast.error('Enter the 6-digit code from your email');
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/login-otp/verify`, { identifier: identifier.trim(), otp: otp.trim() });
      setAuthData(r.data.access_token, r.data.user);
      onDone(r.data.user);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Incorrect or expired code');
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="w-full mt-3 py-2.5 rounded-lg border border-[#D4AF37]/50 text-[#D4AF37] text-sm flex items-center justify-center gap-2 hover:bg-[#D4AF37]/10 transition-colors" data-testid="email-otp-open-btn">
        <Mail className="w-4 h-4" /> Login with Email Code
      </button>
    );
  }
  const field = 'w-full px-4 py-3 bg-[#0F0F10] border border-white/10 rounded-lg text-white text-sm focus:border-[#D4AF37] outline-none';
  return (
    <div className="mt-4 p-4 rounded-lg border border-[#D4AF37]/30 space-y-3" data-testid="email-otp-panel">
      <p className="text-sm text-gray-300">We'll email a 6-digit code (valid 10 minutes) to your registered email.</p>
      <input value={identifier} onChange={(e) => setIdentifier(e.target.value)} disabled={sent} placeholder="Member ID or registered email" className={field} data-testid="email-otp-identifier" />
      {sent && (
        <input value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))} inputMode="numeric" placeholder="6-digit code" className={`${field} tracking-[0.4em] text-center`} data-testid="email-otp-code" />
      )}
      <button type="button" onClick={sent ? verify : requestCode} disabled={busy} className="btn-primary w-full flex items-center justify-center gap-2" data-testid={sent ? 'email-otp-verify-btn' : 'email-otp-send-btn'}>
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} {sent ? 'Verify & Login' : 'Send Code'}
      </button>
      {sent && (
        <button type="button" onClick={() => { setSent(false); setOtp(''); }} className="text-xs text-gray-400 hover:text-[#D4AF37]" data-testid="email-otp-resend-btn">Didn't get it? Send again</button>
      )}
    </div>
  );
};
